import {FC} from 'react';
import {StyledFooterInternalLink} from '@/components/footer/FooterGroup.styles';
import {FooterLinkWithLinkAndLabel} from '@/components/footer/FooterGroup';

type FooterInternalLinkProps = {
    link: FooterLinkWithLinkAndLabel,
    fontSize?: number | string;
}

export const FooterInternalLink: FC<FooterInternalLinkProps> = ({
  link,
  fontSize
}) => {
  return <StyledFooterInternalLink fontSize={fontSize} href={link.link}>{link.label}</StyledFooterInternalLink>
}